export default {
  state: {
    airlines: {
      leg1: {
        loading: [],
        selectedCabin: 'Economy',
        Economy: [],
        PremiumEconomy: [],
        Business: [],
        // PremiumBusiness: [],
        First: [],
        API2: [],
        API2Raw: [],
        filtered: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          // PremiumBusiness: [],
          First: [],
          API2: []
        },
        unique: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          // PremiumBusiness: [],
          First: [],
          API2: []
        },
        token: '',
        firstFlightPrice: {
          Economy: 0,
          PremiumEconomy: 0,
          Business: 0,
          // PremiumBusiness: 0,
          First: 0,
          API2: 0
        }
      },
      leg2: {
        loading: [],
        selectedCabin: 'Economy',
        flights: [],
        Economy: [],
        PremiumEconomy: [],
        Business: [],
        // PremiumBusiness: [],
        First: [],
        API2: [],
        API2Raw: [],
        filtered: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          // PremiumBusiness: [],
          First: [],
          API2: []
        },
        unique: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          // PremiumBusiness: [],
          First: [],
          API2: []
        },
        token: '',
        firstFlightPrice: {
          Economy: 0,
          PremiumEconomy: 0,
          Business: 0,
          // PremiumBusiness: 0,
          First: 0,
          API2: 0
        }
      }
    }
  },
  mutations: {
    setAirlinesData (state, data) {
      for (let field in data) {
        state.airlines[field] = data[field]
      }
    },
    setAirlinesLegData (state, data) {
      for (let field in data.fields) {
        state.airlines[data.leg][field] = data.fields[field]
      }
    },
    setAirlinesFilteredData (state, data) {
      for (let field in data.fields) {
        state.airlines[data.leg].filtered[field] = data.fields[field]
      }
    },
    setAirlinesUniqueLegData (state, data) {
      for (let field in data.fields) {
        state.airlines[data.leg].unique[field] = data.fields[field]
      }
    },
    toggleAirlinesLoading (state, data) {
      let i = state.airlines[data.leg].loading.indexOf(data.val)
      if (i > -1) state.airlines[data.leg].loading.splice(i, 1)
      else state.airlines[data.leg].loading.push(data.val)
    },
    unavailableFlight (state, data) {
      if (data.class === 'API2') {
        let API2 = state.airlines[data.leg].API2
        let API2Raw = state.airlines[data.leg].API2Raw
        let i = API2Raw.findIndex(x => x.token === data.token)
        if (i === -1) return

        let i2 = API2.findIndex(x => x.flight[0].flightNo === API2Raw[i].flight[0].flightNo && x.flight[0].airline.code === API2Raw[i].flight[0].airline.code)
        if (i2 === -1) return

        let i3 = state.airlines[data.leg].API2[i2].options.findIndex(x => x.token === API2Raw[i].token)
        if (i3 === -1) return

        state.airlines[data.leg].API2[i2].options[i3].available = false
        let hasAvailable = false
        state.airlines[data.leg].API2[i2].options.forEach(flight => {
          if (flight.available) hasAvailable = true
        })
        if (!hasAvailable) state.airlines[data.leg].API2[i2].available = false
        return
      }

      let i = state.airlines[data.leg][data.class].findIndex(x => x.token === data.token)
      if (i > -1) {
        state.airlines[data.leg][data.class][i].available = false
      }

      i = state.airlines[data.leg].filtered[data.class].findIndex(x => x.token === data.token)
      if (i > -1) {
        state.airlines[data.leg].filtered[data.class][i].available = false
      }
    },
    setFirstFlightPrice (state, data) {
      for (let field in data.fields) {
        state.airlines[data.leg].firstFlightPrice[field] = data.fields[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/airlines.js